"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("./index15.js");require("./index16.js");const a=require("@apollo/client");var e,u=a.gql(e||(e=t.default([`
  mutation createSeatRequest($input: CreateSeatRequestInput!) {
    createSeatRequest(input: $input) {
      success
      seatRequest {
        id
      }
    }
  }
`])));exports.CreateSeatRequestDocument=u;
